export const isNativeContactHref = (href: string | undefined): boolean =>
	href !== undefined && /^(?:mailto|tel):/i.test(href);
